import {greenColors, primary} from '../../layouts/theme/designSystem';

export const getButtonStyles = (type: 'primary' | 'secondary') => {
  if (type === 'primary') {
    return {
      disabled: primary[70],
      hovered: greenColors[100],
      fill: greenColors[700],
      selected: greenColors[700],
      textColor: 'white',
    };
  }
  return {
    disabled: primary[30],
    hovered: greenColors[100],
    fill: greenColors[100],
    selected: greenColors[40],
    textColor: 'white',
    borderColor: greenColors[40],
  };
};
